import { CloseRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import UpdateBrand from "./UpdateBrand";
import UpdateCategory from "./UpdateCategory";
import UpdateSupplier from "./UpdateSupplier";
import UpdateTag from "./UpdateTag";

const UpdateBCST = ({
  setUpdateBCST,
  updateBCST,
  selectedRec,
  setSelectedRec,
}) => {
  const handleClose = () => {
    setUpdateBCST((j) => ({ ...j, open: false }));
    setSelectedRec({ items: [], all: false });
  };

  const renderBody = () => {
    switch (updateBCST.type) {
      case "brand":
        return <UpdateBrand {...{ selectedRec, handleClose }} />;
      case "category":
        return <UpdateCategory {...{ selectedRec, handleClose }} />;
      case "supplier":
        return <UpdateSupplier {...{ selectedRec, handleClose }} />;
      case "tag":
        return <UpdateTag {...{ selectedRec, handleClose }} />;
      default:
        break;
    }
  };

  return (
    <div className="flex flex-col max-h-[90vh]">
      {/* ======= Header ======== */}
      <div className="flex justify-between items-center gap-2 border-b p-[4px]">
        <span className="text-[16px] ml-[10px] uppercase text-gray-600 font-medium tracking-wide">
          Update the {updateBCST.type} for {selectedRec.items.length} products
        </span>
        <div className="flex gap-2 m-1">
          <IconButton size="small" color="error" onClick={handleClose}>
            <CloseRounded />
          </IconButton>
        </div>
      </div>
      <div className="p-3">{renderBody()}</div>
    </div>
  );
};

export default UpdateBCST;
